<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add Insemination Log

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px">








            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                  Emergency Contact(Family)


                </div>-->

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName"><span>*</span> Date</label>
                      </div>

                      <div class="col-md-4">
                        <div class="date-form">
                          <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp1" [(ngModel)]="NewDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                          <a (click)="d1.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>
                        <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                        <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                               [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                               name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="firstName"> Time</label>
                      </div>
                      <!--<div class="col-md-4 margin-tg-auto">

                        <div class="date-form">
                          <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp1" [(ngModel)]="Time" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                          <a (click)="d2.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>


                      </div>-->
                      <!--<div class="col-md-4 padding-right-0px">
                        <input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="CurrentSaveIvfCycleInseminationLogRequest.InseminationTime" name="CurrentSaveIvfCycleInseminationLogRequest.InseminationTime">
                        <ngx-material-timepicker #picker></ngx-material-timepicker>



                      </div>-->
                      <!--<div class="col-md-4">

                        <div class="date-form">
                          <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                 name="dp1" [(ngModel)]="Time" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
                          <small class="form-text text-danger"
                                 *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                          <a (click)="d2.toggle()" class="nav-link-hand">
                            <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                          </a>

                        </div>

                      </div>-->

                      <div class="col-md-4 ">

                        <input type="text" class="form-control" id="CurrentSaveIvfCycleInseminationLogRequest.InseminationTimeText"
                               [(ngModel)]="CurrentSaveIvfCycleInseminationLogRequest.InseminationTimeText"
                               name="CurrentSaveIvfCycleInseminationLogRequest.InseminationTimeText"
                               maxlength="20" minlength="1" #InseminationTimeT="ngModel" pattern="^[\sa-zA-Z0-9,:._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!InseminationTimeT.valid && (InseminationTimeT.dirty || InseminationTimeT.touched) && InseminationTimeT.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!InseminationTimeT.valid && InseminationTimeT.errors.pattern)">(special characters are not allowed)</small>
                      </div>

                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right">
                        <label for="diaplayName"><span>*</span> DOC </label>
                      </div>
                      <div class="col-md-4">
                        <CodeTypeValue CodeType="InsDo" id="CurrentSaveIvfCycleInseminationLogRequest.Doc"
                                       [(ngModel)]="CurrentSaveIvfCycleInseminationLogRequest.Doc" SelectedValue=""
                                       name="CurrentSaveIvfCycleInseminationLogRequest.Doc" required>

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row" *ngIf="Gradingmodel !=='Droplet Culture'">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName">No of times per hour </label>
                      </div>
                      <div class="col-md-4 ">

                        <input type="number" class="form-control" id="CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed"
                               [(ngModel)]="CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed"
                               name="CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed"
                               maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
                        <small class="form-text text-danger"
                               *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Embryologist </label>
                      </div>
                      <div class="col-md-4 ">
                        <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                 id="CurrentSaveIvfCycleInseminationLogRequest.Doctor" SelectedValue="CurrentSaveIvfCycleInseminationLogRequest.Doctor"
                                                 [(ngModel)]="CurrentSaveIvfCycleInseminationLogRequest.Doctor" (keyChange)="onAssignedToActorCodeEmbryologist2($event)"
                                                 name="CurrentSaveIvfCycleInseminationLogRequest.Doctor">
                        </CustomDataByRequestType>
                        <!--<label class="margin-top-7px">{{ProviderName}}</label>-->
                      </div>
                      <!--<div class="col-md-2 padding-left-0px margin-top-5px">

                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="DoctorSelection()"> <i class="fas fa-ellipsis-h"></i></button>
                      </div>-->
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName" *ngIf="Gradingmodel =='Well Culture'" class="margin-bottom-0px margin-top-5px">Processed By </label>
                        <label for="diaplayName" *ngIf="Gradingmodel =='Droplet Culture'" class="margin-bottom-0px margin-top-5px">Done By </label>
                      </div>
                      <!--<div class="col-md-4 " *ngIf="Gradingmodel =='Well Culture'">
        <label class="margin-top-7px">{{ProvidedName}}</label>
      </div>-->
                      <div class="col-md-4">
                        <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                 id="CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy" SelectedValue="CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy"
                                                 [(ngModel)]="CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy" (keyChange)="onAssignedToActorCodeEmbryologist($event)"
                                                 name="CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy">
                        </CustomDataByRequestType>
                      </div>
                      <!--<div class="col-md-2 padding-left-0px margin-top-5px">

        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="ProvidedSelection()"> <i class="fas fa-ellipsis-h"></i></button>
      </div>-->
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-4 text-align-right ">
                        <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Witness </label>
                      </div>
                      <div class="col-md-4 ">
                        <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                 id="CurrentSaveIvfCycleInseminationLogRequest.Nurse" SelectedValue="CurrentSaveIvfCycleInseminationLogRequest.Nurse"
                                                 [(ngModel)]="CurrentSaveIvfCycleInseminationLogRequest.Nurse" (keyChange)="onAssignedToActorCodeEmbryologist1($event)"
                                                 name="CurrentSaveIvfCycleInseminationLogRequest.Nurse">
                        </CustomDataByRequestType>
                        <!--<label class="margin-top-7px">{{NurseName}}</label>-->
                      </div>
                      <!--<div class="col-md-2 padding-left-0px margin-top-5px">

                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="NurseSelection()"> <i class="fas fa-ellipsis-h"></i></button>
                      </div>-->
                    </div>


                  </div>
                </div>
                <!--<div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName">Image </label>
                      </div>
                      <div class="col-md-3 ">
                        <input type="file" name="pic" accept="image/*">


                      </div>
                    </div>


                  </div>
                </div>-->


              </div>
            </div>


            <!--<div class="card-footer text-align-center">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
            </div>-->


















          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px margin-right-auto">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
